import "../../utilities/globals/index.js";
export * from "./useApolloClient.js";
export * from "./useLazyQuery.js";
export * from "./useMutation.js";
export { useQuery } from "./useQuery.js";
export * from "./useSubscription.js";
export * from "./useReactiveVar.js";
export * from "./useFragment.js";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/react/hooks/index.js
// module id = 1515
// module chunks = 4